import { cn } from ".";

function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn("animate-pulse rounded-md bg-background", className)}
      {...props}
    />
  );
}

export { Skeleton };
